import React from 'react';
import envConfig from '../../config';
import { getCookie, removeAllCookies } from '../../helper/cookie';
import { smartlookAppend } from '../../helper/smartlook';
import { useConfig } from '../../services/config/config';
import { Loading } from '../ui/loading';

export type ProtectedRouteProps = {
  render: JSX.Element;
};

const validatePersistedSession = () => {
  const token = getCookie('session_token');
  const iduser = getCookie('user_id');
  const clientCod = getCookie('client_cod');

  return token && iduser && clientCod;
};

const logoff = () => {
  const route = envConfig.SITE_URL + '/';
  removeAllCookies();
  window.location.href = route;
};

export const PrivateRoute = ({ render }: ProtectedRouteProps) => {
  const validSession = validatePersistedSession();
  const { fetching, error, data } = useConfig();

  if (!validSession) {
    logoff();
    return null;
  }

  if (fetching) {
    return <Loading />;
  }

  if (error) {
    logoff();
    return null;
  }

  const clientCod = getCookie('client_cod');
  const userId = getCookie('user_id');
  const userEmail = getCookie('user_email');
  const name = data?.NOME;

  smartlookAppend('identify', userId, {
    ...(userEmail && { email: userEmail }),
    ...(clientCod && { clientCod }),
    ...(name && { nome: name }),
  });

  return render;
};
